module.exports = __webpack_public_path__ + "img/pencil-outline-white.c9429d44.svg";